import React              from 'react';
import ReactDOM           from 'react-dom/client';
import './index.css';
import 'simplebar-react/dist/simplebar.min.css'
import App                from './App';
import reportWebVitals    from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter }  from 'react-router-dom'
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
